import '../chart_view.js.coffee';# Added by Script 
import '../../../monitoring/charts/chart_view.js.coffee'

Namespace 'CustomerVisualMode.Charts'

class CustomerVisualMode.Charts.FirstMetricsChartView extends CustomerVisualMode.Charts.ChartView
  template: JST['backbone/templates/customer_visual_mode/charts/first_metrics/first_metrics_chart']
  className: 'grid-item full-width-chart'

  initialize: (options) ->
    @options = options
    super(options)
    # @widget.set('use_work_calendar', true) - Activate when using/not using work calendar
    barMenuViewFactory = new Common.Dashboard.Charts.BarMenuViewFactory(
      exportable: false,
      resizable: false
    )
    @barMenuView = barMenuViewFactory.create(@widget, @data)
    @barMenuView.customOptionViews.map((view) => @listenTo(view, view.toggleEventName, view.getToggleMethod(@)))
    @_updateData()

  render: ->
    super()
    @_renderCharts()
    # @$el.find('.chart-actions').children().last().before(@barMenuView.render().el)
    # Activate when using/not using work calendar
    @

  _renderCharts: ->
    @$el.find('.chart').html(@template)
    @$el.find('.first-opened-to-assigned').append(@_firstOpenedToAssigned().render().el)
    @$el.find('.first-opened-to-responded').append(@_firstOpenedToRespondedView().render().el)
    @$el.find('.first-opened-to-closed').append(@_firstOpenedToCloseView().render().el)

  _updateData: ->
    usingWorkCalendar = @widget.get('use_work_calendar')
    if usingWorkCalendar || usingWorkCalendar == undefined
      @currentData = @data.with_calendar
    else
      @currentData = @data.without_calendar

  _firstOpenedToRespondedView: ->
    new CustomerVisualMode.Charts.AverageTimeChartView({
      sla: @currentData.sla.opened_responded,
      compliesWithSlaCount: @currentData.sla_fulfilling_first_response_since_creation,
      uncompliesWithSlaCount: @currentData.sla_unfulfilling_first_response_since_creation,
      averageTimeInSeconds: @currentData.average_first_response_since_creation,
      translations: {
        title: I18n.t('customer_visual_mode.charts.first_metrics.first_opened_to_responded'),
        sla: I18n.t('customer_visual_mode.charts.first_metrics.sla'),
        total: I18n.t('customer_visual_mode.charts.first_metrics.total'),
        drilldownTitle: @title + ' / ' +
                        I18n.t('customer_visual_mode.charts.first_metrics.first_opened_to_responded')
      },
      clickable: true,
      dimension: 'first_opened_to_responded',
      widgetName: @constructor.NAME,
      currentData: @currentData,
      options: @options
    })

  _firstOpenedToCloseView: ->
    new CustomerVisualMode.Charts.AverageTimeChartView({
      sla: @currentData.sla.opened_closed,
      compliesWithSlaCount: @currentData.sla_fulfilling_first_opened_to_closed,
      uncompliesWithSlaCount: @currentData.sla_unfulfilling_first_opened_to_closed,
      averageTimeInSeconds: @currentData.average_first_opened_to_closed,
      translations: {
        title: I18n.t('customer_visual_mode.charts.first_metrics.first_opened_to_closed'),
        sla: I18n.t('customer_visual_mode.charts.first_metrics.sla'),
        total: I18n.t('customer_visual_mode.charts.first_metrics.total'),
        drilldownTitle: @title + ' / ' +
                        I18n.t('customer_visual_mode.charts.first_metrics.first_opened_to_closed')
      },
      clickable: true,
      dimension: 'first_opened_to_closed',
      widgetName: @constructor.NAME,
      currentData: @currentData,
      options: @options
    })

  _firstOpenedToAssigned: ->
    new CustomerVisualMode.Charts.AverageTimeChartView({
      sla: @currentData.sla.opened_assigned,
      compliesWithSlaCount: @currentData.sla_fulfilling_first_assignation_since_creation,
      uncompliesWithSlaCount: @currentData.sla_unfulfilling_first_assignation_since_creation,
      averageTimeInSeconds: @currentData.average_first_assignation_since_creation,
      translations: {
        title: I18n.t('customer_visual_mode.charts.first_metrics.first_opened_to_assigned'),
        sla: I18n.t('customer_visual_mode.charts.first_metrics.sla'),
        total: I18n.t('customer_visual_mode.charts.first_metrics.total'),
        drilldownTitle: @title + ' / ' +
                        I18n.t('customer_visual_mode.charts.first_metrics.first_opened_to_assigned')
      },
      clickable: true,
      dimension: 'first_opened_to_assigned',
      widgetName: @constructor.NAME,
      currentData: @currentData,
      options: @options
    })

  toggleUseWorkCalendar: ->
    @widget.set('use_work_calendar', !@widget.get('use_work_calendar'))
    @_updateData()
    @_updateTitle(@_getTitle())
    @_renderCharts()
